import { keepPreviousData, useInfiniteQuery } from '@tanstack/vue-query';
import { useSupportStore } from '#modules/support/stores/support.store.js';
import api from '@/app/api/axios.js';
import { transformFilters } from '@/shared/utils/transform-filters.js';
import { SupportStatus } from '#modules/support/models/SupportStatus.js';
import { storeToRefs } from 'pinia';

export function useSupportMessagesQuery() {
    const store = useSupportStore();
    const { onlyPersonalTickets, onlyOpenTickets, searchQuery, sort } = storeToRefs(store);

    return useInfiniteQuery({
        queryKey: ['support-messages', { onlyPersonalTickets, onlyOpenTickets, searchQuery, sort }],
        queryFn: async ({ pageParam = 1 }) => {
            const { data } = await api.get('/general/support-messages', {
                params: transformFilters({
                    page: pageParam,
                    per_page: 10,
                    group: onlyPersonalTickets.value ? 'user' : 'team',
                    status: onlyOpenTickets.value
                        ? [SupportStatus.WaitingForCyberfusion, SupportStatus.WaitingForUser]
                        : null,
                    search: searchQuery.value || null,
                    sort: sort.value,
                }),
            });

            const currentPage = data.meta.current_page;
            const lastPage = data.meta.last_page;

            return {
                data: data.data,
                cursor: currentPage < lastPage ? currentPage + 1 : undefined,
            };
        },
        getNextPageParam: (lastPage) => lastPage.cursor,
        refetchOnWindowFocus: false,
        placeholderData: keepPreviousData,
    });
}
